import styled, { css } from 'styled-components'
import { darken } from 'polished'
const Button = styled.button`
  width: ${(props) => (props.fluid ? '100%' : '200px')};
  width: ${(props) => {
    switch (props.size) {
      case 'large':
        return '250px'
      default:
        return '150px'
    }
  }};
  border-radius: 12px;
  /*
  ** BACKGROUND COLOR
  */
  ${(props) =>
    props.color && !props.noTheme
      ? css`
          background: ${(props) => props.theme[props.color]};
          transition: 0.1s;
          &:hover {
            background: ${darken(0.1, props.theme[props.color])};
          }
        `
      : props.noTheme && !props.disabled
      ? css`
          background: #405c63;
        `
      : props.noTheme && props.disabled
      ? css`
          background: #405c63;
          opacity: 0.5;
        `
      : css`
          /*
    ** Default Background color
    */

          background: ${(props) => props.theme.purple};
        `};
  ${(props) => (props.transparent ? 'background: transparent;' : '')}
  display: ${(props) =>
    props.inline && !props.flex
      ? 'inline-block'
      : props.flex
      ? 'flex'
      : 'block'};
  color: white;
  font-size: ${(props) => (!props.fontSize ? props.fontSize : '20px')};
  font-weight: ${(props) => (!props.bold ? '500' : '800')};
  border: none;
  height: 48.398px;
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  text-decoration: none;

  ${(props) =>
    props.outline
      ? css`
          background: white;
          color: ${(props) => props.theme.charcoal};
          border: 3px solid ${(props) => props.theme.charcoal};
          padding: 15px 0px;

          &:hover {
            background: ${(props) => props.theme.charcoal};
            color: white;
          }
        `
      : ''};
`

export default Button
